<template>
  <div>
    <EmailSendingHistory />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import EmailSendingHistory from "../../components/views/gethering/EmailSendingHistory.vue";
export default defineComponent({
  components: {
    EmailSendingHistory
  },
  setup() {}
});
</script>
